import type { HTMLAttributes } from 'react';
import clsx from 'clsx';

interface Props extends HTMLAttributes<HTMLElement> {
  /** 'sky' points somewhere else; 'navy' is the single "get in touch" box a page may have. */
  tone?: 'sky' | 'navy';
}

export function Callout({ tone = 'sky', className, ...rest }: Props) {
  return (
    <aside
      className={clsx('px-7 py-6', tone === 'navy' ? 'bg-navy-900 text-white' : 'bg-sky-50', className)}
      {...rest}
    />
  );
}
